<template>
  <section class="hero">
    <div
      v-if="carouselMovies || carouselBanners"
      class="hero-slider">
      <div
        v-for="movie in carouselMovies"
        :key="movie.id"
        class="hero-slide">
        <div class="hero-media">
          <figure class="image">
            <img
              :src="movie.backdrop.guid"
              :alt="movie['movie-name']"
              :title="movie['movie-name']"
              width="100w">
          </figure>
        </div>
        <div class="info">
          <div class="movie-logo">
            <img
              :src="movie.logo.guid"
              :alt="movie['movie-name']"
              :title="movie['movie-name']">
          </div>
          <div class="movie-meta">
            <span class="year">{{ movie.year }}</span>
            <span class="maturity-rating">{{ movie.rating[0] }}</span>
            <span class="duration">{{ movie.runtime }}</span>
          </div>
          <div class="movie-synopsis">
            <p>{{ movie['short-plot'] }}</p>
          </div>
          <div class="movie-actions">
            <div class="buttons">
              <a
                class="button is-small is-link btn-movie-play-trailer"
                @click="openTrailerModal(movie.trailer)">
                <span class="icon">
                  <play-icon/>
                </span>
                <span>Reproducir tráiler</span>
              </a>
              <a
                class="button is-small is-outlined is-white btn-movie-more-info"
                @click="openMovieModal(movie)">
                <span class="icon">
                  <clock-outline-icon/>
                </span>
                <span>Ver Horarios</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="banner in carouselBanners"
        :key="banner.id"
        class="hero-slide">
        <div class="hero-media">
          <figure class="image">
            <img
              :src="banner.image.guid"
              class="top"
              width="100w">
          </figure>
        </div>
        <div class="info">
          <h3 class="slide-title">{{ banner['banner-title'] }}</h3>
          <p
            v-if="banner.description"
            class="slide-description">{{ banner.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider';
import PlayIcon from 'vue-material-design-icons/Play.vue';
import ClockOutlineIcon from 'vue-material-design-icons/ClockOutline.vue';
import InformationOutlineIcon from 'vue-material-design-icons/InformationOutline.vue';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'Hero',
  components: {
    InformationOutlineIcon,
    PlayIcon,
    ClockOutlineIcon,
  },
  computed: {
    ...mapState([
      'carouselBanners',
    ]),
    ...mapGetters([
      'carouselMovies',
    ]),
  },
  updated() {
    if (this.carouselBanners.length > 0 && this.carouselMovies.length > 0) {
      tns({
        container: '.hero-slider',
        items: 1,
        autoplay: true, // debug: false
        mode: 'gallery',
        autoplayButtonOutput: false,
        autoplayHoverPause: true,
        lazyload: true,
        controls: false,
        nav: false,
        mouseDrag: true,
        swipeAngle: false,
        speed: 1000,
        useLocalStorage: false,
      });
    }
  },
  methods: {
    ...mapActions([
      'openTrailerModal',
      'openMovieModal',
    ]),
  },
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/initial-variables";
@import "~bulma/sass/utilities/functions";
@import "~bulma/sass/utilities/derived-variables";
@import "~bulma/sass/utilities/mixins";
@import '~tiny-slider/src/tiny-slider';

.hero-slide .hero-media .image {
  padding-bottom: 56.25%;
  overflow: hidden;

  @include from(960px) {
    padding-bottom: 40%;
  }

  img {
    @include overlay();
    left: unset;
    height: 100%;
    width: unset;
    transform: translateX(12.5%);

    @include from(960px) {
      transform: none;
    }
  }

  &:after {
    content: '';
    background: linear-gradient(to bottom, #000 0%, rgba(0, 0, 0, 0) 100%);
    height: 12.8vw;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    opacity: .65;
  }

  &:before {
    content: '';
    background: linear-gradient(to right, #000 0, #000 25%, transparent 75%, transparent 100%);
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    z-index: 2;

    @include from(960px) {
      width: 72%;
      background: linear-gradient(to right, #000 0, transparent 50%, transparent 100%);
    }
  }
}

.hero-slide {
  position: relative;
}

.hero {
  margin-bottom: 2.5rem;

  .info {
    position: absolute;
    width: 92%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 4%;
    right: 0;
    z-index: 10;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include from(960px) {
      width: 40%;
    }

    .movie-logo {
      width: 50%;

      @include from(960px) {
        width: 75%;
      }
    }

    .movie-meta {
      display: flex;
      color: #fff;
      font-weight: bold;
      font-size: 0.75rem;
      align-items: center;
      margin-top: 0.5rem;

      @include from(960px) {
        margin-top: 0.75rem;
      }

      span {
        margin-right: 5px;
      }

      .maturity-rating {
        height: 2em;
        display: inline-flex;
        border-radius: 4px;
        align-items: center;
        justify-content: center;
        line-height: 1.5;
        padding-left: 0.75em;
        padding-right: 0.75em;
        white-space: nowrap;
        border: solid 1px rgba(255,255,255,.4);
      }
    }

    .movie-synopsis {
      display: none;
      color: #fff;
      width: 50%;
      margin-top: 0.5rem;
      font-size: 0.95rem;

      @include from(640px) {
        display: block;
      }

      @include from(960px) {
        margin-top: 0.75rem;
        width: 90%;
      }
    }

    .movie-actions {
      display: flex;
      align-items: center;
      margin-top: 0.5rem;
      font-weight: bold;

      @include from(960px) {
        margin-top: 0.75rem;
      }

      .button {
        margin-bottom: 0;

        @include from(500px) {
          font-size: 1rem;

          .icon {
            span {
              width: 90%;
              height: 90%;
            }
          }
        }
      }

      .btn-movie-more-info {
        background-color: rgba(0,0,0, 0.2);

        &:hover {
          background-color: white;
        }
      }
    }

    .slide-title {
      color: #fff;
      width: 60%;
      font-weight: bold;
      font-size: 1rem;

      @include from(540px) {
        font-size: 1.5rem;
      }

      @include from(960px) {
        font-size: 2rem;
        width: 100%;
      }
    }

    .slide-description {
      display: none;
      color: #fff;
      width: 50%;
      margin-top: 0.5rem;

      @include from(540px) {
        display: block;
      }

      @include from(960px) {
        width: 90%;
        margin-top: 0.75rem;
      }
    }

    .btn-slide-more-info {
      font-weight: bold;
      margin-top: 0.75rem;
      margin-bottom: 0;

      @include from(960px) {
        margin-top: 1.25rem;
      }
    }
  }
}
</style>
